import React, { useState, useEffect } from "react";

import { withStyles } from "@material-ui/core/styles";
import { KeyboardArrowLeft } from "@material-ui/icons";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputBase from "@material-ui/core/InputBase";
import GoogleLogin from "react-google-login";
import PropTypes from "prop-types";

import { ErrorMessage } from "../ErrorMessage";
import { years } from "./yearsData";
import { months } from "./monthsData";
import { days } from "./daysData";
import { CustomButton } from "../../../../components/ui-kit/CustomButtom";
import { TermsAndConditionsFooter } from "../TermsAndConditionFooter";

import { useTranslation } from 'react-i18next';

import { getTenant } from "multitenancy/multitenancyGetTenant";

import "./style.scss";

export const AuthFormLogin = ({
  confirmSSNStep,
  // goToAccessCodeStep,
  handleConfirmWithGoogleLogin,
  handleGoBack,
  handleChange,
  handleAccountNumberChange,
  handleFiletNumberChange,
  handleChangeMonthsSelect,
  handleChangeDaysSelect,
  handleChangeYearsSelect,
  currentMonth,
  currentDay,
  currentYear,
  handleLogin,
  handleGoogleLogin,
  defaultSSN,
  defaultAccountNumber,
  defaultFileNumber,
  defaultLastName,
  tab,
  setTab,
  errorMessage,
  hasError,
  disableLogin_3_sec,
  disableGoogleLogin
}) => {

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const { t } = useTranslation();

  useEffect(() => {
    if (disableLogin_3_sec) {
      setIsButtonDisabled(true);
      setTimeout(function() {
        setIsButtonDisabled(false);
      }, 3000);
    }

  }, [disableLogin_3_sec]);


  const toggleTabs = () => {
    setTab(!tab);
  };

  const BootstrapInput = withStyles((theme) => ({
    root: {
      "label + &": {
        marginTop: theme.spacing(3),
      },
    },
    input: {
      borderRadius: 8,
      position: "relative",
      backgroundColor: "white",
      border: "none",
      height: 56,
      lineHeight: "56px",
      fontSize: 16,
      padding: "0px 16px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
    },
  }))(InputBase);

  // const goToLogin2 = () => {
  //   window.location.replace("/login-2");
  // }
  
  return (
    <div className="auth-form-login">
      {confirmSSNStep ?
        <div className="auth-form__header">
          <h3 className="heading heading-1">{t("Confirm Your Identity")}</h3>
          <p>{t("Please enter the information below to connect your Google account")}</p>
          <button
            className="button button-text--simple"
            onClick={() => handleGoBack()}
          >
            <KeyboardArrowLeft />
          </button>
          {hasError ? <ErrorMessage errorMessage={errorMessage} /> : null}
        </div> 
      : 
        <div className="auth-form__header">
          <h2 className="heading heading-1">{t("Access Your Account")}</h2>
          {hasError ? <ErrorMessage errorMessage={errorMessage} /> : null}

          {disableGoogleLogin ? (
            <div className="gray-error">{t("If you want to login with Google please enable third-party cookies")}</div>
          ) : (
            <>
              <GoogleLogin
                className="google-login-btn"
                clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
                buttonText={t("Sign in with Google")}
                onSuccess={handleGoogleLogin}
                onFailure={handleGoogleLogin}
                cookiePolicy={'single_host_origin'}
                uxMode="popup"
              />
              <div className="or-block-container">
                <hr></hr> 
                <span>OR</span>
                <hr></hr>
              </div>
            </>
          )}
          {/* <GoogleLogin
            className="google-login-btn"
            clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
            buttonText="Sign in with Google"
            onSuccess={handleGoogleLogin}
            onFailure={handleGoogleLogin}
            cookiePolicy={'single_host_origin'}
            uxMode="popup"
          /> */}

        </div>
      }

      <div className="auth-form__inputs-horizontal d-flex justify-content-between">
        <div className="form-group">
          <label htmlFor="last_name">{t("Last Name")}</label>
          <input
            className="form-control"
            placeholder={t("Your Last Name")}
            type="text"
            id="last_name"
            name="last_name"
            onChange={handleChange}
            defaultValue={defaultLastName}
          />
        </div>
        <div className="form-group">
          <label htmlFor="social-security-number">
            SSN <small className="text-muted">{t("Last 4 digits")}</small>
          </label>
          <input
            className="form-control"
            placeholder="XXXX"
            type="number"
            id="social-security-number"
            name="ssn"
            onChange={handleChange}
            value={defaultSSN}
          />
        </div>
      </div>
      <div className="auth-form__tabs tabs">
        <div className="auth-form__tabs-content tabs-content">
          {tab ? (
            <div className="form-group" id="user-account-number">
              <div className="label-tab-toggle">
                <label htmlFor="account_number">
                  {getTenant() === "consuegra" ? t("File Number") : t("Account Number")}{" "}
                  {getTenant() !== "consuegra" && (
                    <small className="text-muted">{t("Last 4 digits")}</small>
                  )}
                </label>
                <button
                  className="btn-toggle-tabs"
                  onClick={() => toggleTabs()}
                >
                  {t("Use Date of Birth")}
                </button>
              </div>
              {getTenant() === "consuegra" ? (
                <input
                  id="fileNumber"
                  name="file_number"
                  className="form-control"
                  placeholder="XXXXXXX"
                  type="text"
                  onChange={handleFiletNumberChange}
                  value={defaultFileNumber}
                />
              ) : (
                <input
                  id="accountNumber"
                  name="account_number"
                  className="form-control"
                  placeholder="XXXX"
                  type="text"
                  onChange={handleAccountNumberChange}
                  value={defaultAccountNumber}
                />
              )}
            </div>
          ) : (
            <div className="form-group" id="user-birdth-date">
              <div className="label-tab-toggle">
                <label htmlFor="birth-date">{t("Date of Birth")}</label>
                <button
                  className="btn-toggle-tabs"
                  onClick={() => toggleTabs()}
                >
                  {getTenant() === "consuegra" ? t("Use File Number"): t("Use Account Number")}
                </button>
              </div>
              <div className="date-of-birth-wrapper">
                <FormControl className="date-of-birth__select months-select">
                  <Select
                    labelId="demo-customized-select-label"
                    id="demo-customized-select"
                    defaultValue={currentMonth}
                    onChange={handleChangeMonthsSelect}
                    input={<BootstrapInput />}
                  >
                    {months.map((month, i) => (
                      <MenuItem key={i} value={month.value}>
                        {t(month.title)}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl className="date-of-birth__select days-select">
                  <Select
                    labelId="demo-customized-select-label"
                    id="demo-customized-select"
                    defaultValue={currentDay}
                    onChange={handleChangeDaysSelect}
                    input={<BootstrapInput />}
                  >
                    {days.map((day, i) => (
                      <MenuItem key={i} value={day.value}>
                        {t(day.title)}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl className="date-of-birth__select years-select">
                  <Select
                    labelId="demo-customized-select-label"
                    id="demo-customized-select"
                    defaultValue={currentYear}
                    onChange={handleChangeYearsSelect}
                    input={<BootstrapInput />}
                  >
                    {years.map((year, i) => (
                      <MenuItem key={i} value={year.value}>
                        {t(year.title)}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </div>
          )}
        </div>
      </div>
      {confirmSSNStep ? 
        <div className="auth-form__submit ssn-verification">
          <CustomButton
            text={t("Confirm")}
            size="large"
            onClickHandler={handleConfirmWithGoogleLogin}
            buttonId="confirm-button"
          />
        </div>
      : 
        <div className="auth-form__submit">
          <CustomButton
            onClickHandler={handleLogin}
            buttonId="submit-button"
            text={t("Access Account")}
            disabled={isButtonDisabled}
          />
          {/* <CustomButton
            buttonId="access-code-btn"
            text="I have an access code"
            onClickHandler={() => goToLogin2()}
          /> */}
        </div>
      }
      <TermsAndConditionsFooter/>
    </div>
  );
};

AuthFormLogin.propTypes = {
  confirmSSNStep: PropTypes.bool,
  goToAccessCodeStep: PropTypes.func,
  handleConfirmWithGoogleLogin: PropTypes.func,
  handleGoBack: PropTypes.func,
  handleChange: PropTypes.func,
  handleAccountNumberChange: PropTypes.func,
  handleChangeMonthsSelect: PropTypes.func,
  handleChangeDaysSelect: PropTypes.func,
  handleChangeYearsSelect: PropTypes.func,
  currentMonth: PropTypes.string,
  currentDay: PropTypes.string,
  currentYear: PropTypes.string,
  handleLogin: PropTypes.func,
  handleGoogleLogin: PropTypes.func,
  defaultSSN: PropTypes.string,
  defaultAccountNumber: PropTypes.string,
  defaultLastName: PropTypes.string,
  tab: PropTypes.bool,
  setTab: PropTypes.func,
  errorMessage: PropTypes.string,
  hasError: PropTypes.bool,
  disableLogin_3_sec: PropTypes.bool,
};
